module.exports = "https://coursera_assets.s3.amazonaws.com/images/f253bc6a4c0fc3a7c4e0c4079658fe5f.jpg";